import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

import { hexToRgb, hsbToRgb, rgbToHsb } from 'utils/colors'

interface PropsButton {
  bgColor?: string
  textColor?: string
  buttonSize?: 'small' | 'large'
}

export const StyledCardWrapper = styled.a`
  position: relative;
  width: 100%;
  border-radius: ${theme.borderRadius};
  overflow: hidden;
  display: grid;

  // ${MediaQueries.mbUp} {
  //   max-width: 268px;
  //   height: 357px;
  // }
  // ${MediaQueries.mbDown} {
  //   max-width: 165px;
  //   height: 220px;
  // }

  &[data-cards-per-row='1'] {
    ${MediaQueries.mbDown} {
      max-width: 343px;
      height: 457px;
    }
  }

  &[data-cards-per-row='2'] {
    ${MediaQueries.mbDown} {
      height: 234px;
    }
  }
  .premium {
    position: absolute;
    top: 8px;
    left: 8px;
  }
`
export const StyledButtonSpotlight = styled.a<PropsButton>`
  position: absolute;
  bottom: 8px;
  left: 8px;
  right: 8px;
  height: ${(props) => (props.buttonSize === 'large' ? '40px' : '32px')};
  padding: ${(props) =>
    props.buttonSize === 'large' ? '8px 16px' : '6px 12px'};

  background: ${(props) => props.bgColor};
  border-radius: 10px;
  border: none;
  transition: all 0.2s ease-in-out;

  color: ${(props) => props.textColor};
  font-weight: 500;
  font-size: ${(props) => (props.buttonSize === 'large' ? '15px' : '14px')};
  line-height: ${(props) => (props.buttonSize === 'large' ? '24px' : '20px')};
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    background: ${(props) => {
      const bgColor = props.bgColor?.toLowerCase()
      if (bgColor === '#ffffff' || bgColor === 'white' || bgColor === '#fff') {
        return '#f0f0f0'
      }
      if (typeof bgColor === 'string') {
        const rgb: any = hexToRgb(bgColor, true)
        const hsb = rgbToHsb(rgb.r, rgb.g, rgb.b)
        const newPattern1 = hsbToRgb(hsb[0], hsb[1] + 16, hsb[2] - 16)
        return `rgb(${newPattern1[0]},${newPattern1[1]},${newPattern1[2]})`
      }
      return ''
    }};
  }
`

export const StyledSeemoreButton = styled.div`
  position: absolute;
  right: 16px;
  bottom: 16px;
  padding: 12px 24px;
  border: 2px solid #2d87f3;
  background: white;
  border-radius: ${theme.borderRadius};
  color: ${theme.colors.primaryActive};
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  &[data-cards-per-row='1'] {
    ${MediaQueries.mbDown} {
      padding: 12px 24px;
      font-size: 16px;
      right: 16px;
      bottom: 16px;
    }
  }
  &[data-cards-per-row='2'] {
    ${MediaQueries.mbDown} {
      padding: 8px 16px;
      font-size: 10px;
      right: 8px;
      bottom: 8px;
    }
  }
`
